<template>
  <div :class="['relative', 'bg_linear_to_r', 'pt-4']">
    <div :class="['page_view', 'flex items-center justify-center']">
      <!-- 按钮组容器 -->
      <div
        :class="[
          'relative isolate',
          'grid grid-cols-2 gap-1',
          'w-full max-w-4xl',
          // 背景中间横杠，造成连接多个按钮的视觉效果
          'before:absolute before:top-1/2 before:-translate-y-1/2 before:w-full before:h-20 before:bg-default',
        ]"
      >
        <!-- 单个按钮 -->
        <a
          v-for="(item, index) in btnItems"
          :key="index"
          :class="[
            'relative',
            'flex flex-col items-center justify-center gap-y-1',
            'py-10 px-2',
            'size-full',
            'bg-gray-50 hover:brightness-105 active:brightness-95',
            'text-center hover:[&_h4]:text-primary',
            'shadow-xl',
            'hover:-translate-y-2 active:-translate-y-1',
            'transition-all',
            // 模拟按钮底部侧面
            'after:absolute after:-bottom-2 after:w-full after:h-2 after:bg-default/50',
            'hover:cursor-pointer select-none',
            // 第一个
            { 'rounded-tl-2xl': index === 0 },
            // 最后一个
            { 'rounded-tr-2xl': index === btnItems.length - 1 },
          ]"
          @click="useLocalePush(item.to)"
        >
          <UIcon :name="item.icon" :class="['lg:text-5xl text-3xl', 'text-primary']" />
          <h4 :class="['lg:text-2xl text-lg font-bold uppercase', 'transition_colors']">
            {{ t(item.title) }}
          </h4>
          <p :class="['lg:text-md text-sm text-default/60']">{{ t(item.desc) }}</p>
        </a>
        <!-- 装饰背景层 -->
        <!-- <div class="absolute size-full bg-secondary z-[-2] rounded-t-2xl overflow-hidden" /> -->
      </div>
    </div>
    <!-- 底部装饰线条 -->
    <div :class="['relative z-1', 'h-2.5', 'bg-primary']" />
  </div>
</template>

<script lang="ts" setup>
  const { t } = useI18n()

  const btnItems = [
    {
      title: 'page.order.create.title',
      desc: 'page.order.create.subTitle',
      icon: 'mdi:truck-outline',
      to: '/order/create',
    },
    {
      title: 'page.track.order.title',
      desc: 'page.track.order.subTitle',
      icon: 'mdi:magnify',
      to: '/track/order',
    },
  ]
</script>
